export default __webpack_public_path__ + "static/media/SouthCarolina.57ba956a.jpg";